import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=22e11dc1&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.scss?vue&type=style&index=0&id=22e11dc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e11dc1",
  null
  
)

export default component.exports